/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{56AD3E50-3A16-4400-A453-5A310903D6FA}",
  "sitecoreApiHost": "https://www.emergingtechnologiesinstitute.org",
  "jssAppName": "ndia-eti",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/ndia-eti",
  "graphQLEndpoint": "https://www.emergingtechnologiesinstitute.org/api/ndia-eti?sc_apikey={56AD3E50-3A16-4400-A453-5A310903D6FA}"
};